import moment from 'moment';

import { ProposalProps, ProposalStatus } from '~/data/proposals';

export const filterAndSortEmploymentProposals = (
  proposals: ProposalProps[],
) => {
  return proposals
    .filter((prop) => prop.proposalStatus !== ProposalStatus.FAILED)
    .sort((prop2, prop1) => moment(prop1.createdTime).diff(prop2.createdTime));
};
